//#region src/utils/rpc-interceptors.ts
function rpcRequestInterceptorLogger(request) {
	console.log(`🛫 ${request.scope} ▪️ ${request.procedure} ▪️ ${request.version || ""}`, `args =>`, request.args);
	return request;
}
function rpcResponseInterceptorLogger(response, request) {
	const title = `🛬 ${!response.success ? `❌ ${response.message}` : "✅"} ${request.scope} ▪️ ${request.procedure} ▪️ ${request.version || ""}`;
	console.groupCollapsed(title);
	if (request.args) console.log("Request:", request.args);
	if (response.data) console.log("Response:", response.data);
	console.groupEnd();
	return response;
}
//#endregion
export { rpcRequestInterceptorLogger, rpcResponseInterceptorLogger };

//# sourceMappingURL=rpc-interceptors.js.map